var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassBus = function SvgPassBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    d: "M5.25 14a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zM14.75 14a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M11.52 12.5H8.48c-.24 0-.48.225-.48.45v.6c0 .225.24.45.48.45h3.04c.24 0 .48-.225.48-.45v-.6c0-.225-.24-.45-.48-.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3.5H3M18 10H2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M17.619 2.275c0-.75-.686-1.275-1.371-1.275H3.752c-.762 0-1.447.525-1.447 1.275L2 10.75v4.725c0 .3.229.525.533.525h14.934a.517.517 0 0 0 .533-.525V10.75z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 16v1.25c0 .667-.583 1.25-1.25 1.25s-1.25-.583-1.25-1.25V16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M6 16v1.25c0 .667-.583 1.25-1.25 1.25s-1.25-.583-1.25-1.25V16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.5 16v1.25c0 .667-.583 1.25-1.25 1.25S14 17.917 14 17.25V16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M16.5 16v1.25c0 .667-.583 1.25-1.25 1.25S14 17.917 14 17.25V16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.038 10.577H1.27c-.461 0-.769-.308-.769-.77V8.27c0-.461.308-.769.77-.769h.768"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M2.038 10.577H1.27c-.461 0-.769-.308-.769-.77V8.27c0-.461.308-.769.77-.769h.768"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.077 10.5h.75c.45 0 .75-.3.75-.75v-1.5c0-.45-.3-.75-.75-.75h-.75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M18.077 10.5h.75c.45 0 .75-.3.75-.75v-1.5c0-.45-.3-.75-.75-.75h-.75"
  })));
};
export default SvgPassBus;